/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { Router, Route } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import SendFormPage from 'infrastructure/email/sendEmail/SendForm';
import UpdateSendEmail from 'infrastructure/email/sendEmail/createupdate/Update';
import { SEND_EMAIL_PATH, useSendEmailRoute } from 'infrastructure/email/sendEmail/sendEmailRouting';

const SendEmailRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { singleEntityRoute, updateRoute } = useSendEmailRoute();

  return (
    <ProtectedRouter basePath={SEND_EMAIL_PATH}>
      <Routes>
        <Route path={singleEntityRoute} element={<SendFormPage />} />

        <Route path={updateRoute} element={<UpdateSendEmail />} />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

SendEmailRouter.getRouterPath = () => `${SEND_EMAIL_PATH}/*`;

export default SendEmailRouter;
